/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/no-unresolved */
import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Box, Card, IconButton, Button,
} from "@mui/material";
import { Link } from "react-router-dom";
import Modal from "react-responsive-modal";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import "./ShopItemBox.scss";
import * as Actions from "actions";
import { getLogo } from "helpers/utils";

const ShopItemBox = (props) => {
  const [state, setState] = useState({
    open: false,
    stock: "InStock",
    quantity: 1,
    image: "",
  });
  const {
    shop, onAddToFavlistClicked, popularproducts, usergetPopularProducts, history,
  } = props;

  // const onClickHandle = (img) => {
  //   setState({ image: img });
  // };
  const onOpenModal = () => {
    setState({ open: true });
    usergetPopularProducts(shop.id, true, false);
  };

  const onCloseModal = () => {
    setState({ open: false });
  };

  // const minusQty = () => {
  //   if (state.quantity > 1) {
  //     setState({ stock: "InStock" });
  //     setState({ quantity: state.quantity - 1 });
  //   }
  // };

  // const plusQty = () => {
  //   if (props.product.stock >= state.quantity) {
  //     setState({ quantity: state.quantity + 1 });
  //   } else {
  //     setState({ stock: "Out of Stock !" });
  //   }
  // };
  // const changeQty = (e) => {
  //   setState({ quantity: parseInt(e.target.value, 10) });
  // };

  const RatingStars = [];
  for (let i = 0; i < shop.ratings; i += 1) {
    RatingStars.push(<i className="fa fa-star" key={i} />);
  }
  return (
    <Card className="product-card">
      <div className="image-container">
        <Box className="front">
          <a
            data-toggle="modal"
            data-target="#quick-view"
            title="Quick View"
            onClick={onOpenModal}
          >
              <img
                src={getLogo(shop.logo)}
                className="product-image"
                alt=""
              />
          </a>
        </Box>
        <Box className="actions" position="absolute" top={0} right={0} display="none" flexDirection="column">
          <IconButton color="secondary" size="small" onClick={onAddToFavlistClicked}>
            <FavoriteBorderIcon />
          </IconButton>
        </Box>
      </div>
      <div className="product-detail">
        <div>
          <div className="rating">
            {RatingStars}
          </div>
          <Link className="styled-link" to={`${process.env.PUBLIC_URL}/shop/${shop.id}`}>
            {shop.title}
          </Link>
        </div>
      </div>
      <Modal open={state.open} onClose={onCloseModal} center>
        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div className="modal-content quick-view-modal">
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-6  col-xs-12">
                  <div className="quick-view-img">
                    <img src={`${shop.images && shop.images[0] ? shop.images[0].cdn.url : "/assets/images/fashion/product/1.jpg"}`} alt="" className="img-fluid" />
                  </div>
                </div>
                <div className="col-lg-6 rtl-text">
                  <div className="product-right">
                    <h2>
                      {shop.title}
                    </h2>
                    <h3>{shop.areaname}</h3>
                    <div className="border-product">
                      <h6 className="product-title">About us</h6>
                      <p>{shop.shortDetails}</p>
                    </div>
                    <div className="border-product">
                      <table className="table cart-table table-responsive-xs">
                        <thead>
                          <tr className="table-head">
                            <th scope="col">Popular items</th>
                          </tr>
                        </thead>
                        {popularproducts.map((shopprice, index) => (
                          <tbody key={`${index + 1}`}>
                            <tr>
                              <td>
                                <Link
                                  to={`${process.env.PUBLIC_URL}/shop/${shopprice._id}`}
                                >
                                  {shopprice.name}
                                </Link>
                              </td>
                              <td>
                                <h6>
                                  {shopprice.price}
                                </h6>
                              </td>
                            </tr>
                          </tbody>
                        ))}
                      </table>
                    </div>

                    <div className="product-buttons">
                      <Button onClick={() => history.push(`/shop/${shop.id}`)} className="btn btn-solid">Visit Shop</Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </Card>
  );
};

ShopItemBox.propTypes = {
  shop: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  onAddToFavlistClicked: PropTypes.func.isRequired,
  usergetPopularProducts: PropTypes.func.isRequired,
  popularproducts: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const ShopItemBoxComponent = connect(
  ({ userproducts, bootupInfo }) => ({
    bootupInfo,
    reqStatus: userproducts.reqStatus,
    isLoading: userproducts.isLoading,
    serviceError: userproducts.serviceError,
    popularproducts: userproducts.popularproducts,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(ShopItemBox);

export default ShopItemBoxComponent;
